import StoreCard from './StoreCard';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';

import Apple from 'images/createAccount/AppleLogo.svg';
import GooglePlay from 'images/createAccount/GooglePlayLogo.svg';
import Windows from 'images/createAccount/WindowsLogo.svg';

const STORES_DATA = [
  {
    label: 'Apple App Store',
    link: 'https://apps.apple.com/us/app/okta-verify/id490179405',
    image: {
      source: Apple,
      width: 49,
      height: 60,
    },
    padding: 0,
    id: 'StoresAppleAppStore',
  },
  {
    label: 'Google Play',
    link:
      'https://play.google.com/store/apps/details?id=com.okta.android.auth&hl=en_US&gl=US',
    image: {
      source: GooglePlay,
      width: 43,
      height: 47,
    },
    padding: 14,
    id: 'StoresGooglePlay',
  },
  {
    label: 'Windows App Store',
    link:
      'https://www.microsoft.com/en-us/p/okta-browser-plugin/9pkzgd0qvlx6?activetab=pivot:overviewtab',
    image: {
      source: Windows,
      width: 53,
      height: 61,
    },
    padding: 0,
    id: 'WindowsAppStore',
  },
];

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  root: {
    [breakpoints.down('sm')]: {
      marginLeft: -8,
    },
  },
  link: {
    '& :hover': {
      '& p': {
        textDecoration: 'none',
      },
    },
    '& .MuiButton-root:hover': {
      backgroundColor: 'transparent',
      boxShadow: '0 0 5px 3px rgba(0, 0, 0, 0.15)',
    },
  },
  button: {
    padding: 0,
    width: 115,
    height: 100,
  },
}));

const Stores = props => {
  const classes = useStyles();
  return (
    <Grid container spacing={0} id="StoresRoot" className={classes.root}>
      {STORES_DATA.map((store, index) => (
        <Grid item xs={4} lg={4} key={`Stores-storeCard-container-${index}`}>
          <Link
            href={store.link}
            className={classes.link}
            id={`${store.id}Link`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className={classes.button}>
              <StoreCard key={`Stores-storeCard-${index}`} data={store} />
            </Button>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};

export default Stores;
